// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import AddToAnyController from "./add_to_any_controller"
application.register("add-to-any", AddToAnyController)

import AdjustmentConfirmModalController from "./adjustment_confirm_modal_controller"
application.register("adjustment-confirm-modal", AdjustmentConfirmModalController)

import AdminBookingStateController from "./admin_booking_state_controller"
application.register("admin-booking-state", AdminBookingStateController)

import AdminFaqController from "./admin_faq_controller"
application.register("admin-faq", AdminFaqController)

import AdminReviewController from "./admin_review_controller"
application.register("admin-review", AdminReviewController)

import AdminSponsorController from "./admin_sponsor_controller"
application.register("admin-sponsor", AdminSponsorController)

import AvailabilityConfirmModalController from "./availability_confirm_modal_controller"
application.register("availability-confirm-modal", AvailabilityConfirmModalController)

import BankAccountFormController from "./bank_account_form_controller"
application.register("bank-account-form", BankAccountFormController)

import BookingCalendarController from "./booking_calendar_controller"
application.register("booking-calendar", BookingCalendarController)

import BookingStepsController from "./booking_steps_controller"
application.register("booking-steps", BookingStepsController)

import CharacterCountController from "./character_count_controller"
application.register("character-count", CharacterCountController)

import CheckboxCollapseController from "./checkbox_collapse_controller"
application.register("checkbox-collapse", CheckboxCollapseController)

import ClipboardController from "./clipboard_controller"
application.register("clipboard", ClipboardController)

import CollapsibleFieldsController from "./collapsible_fields_controller"
application.register("collapsible-fields", CollapsibleFieldsController)

import CreditToggleController from "./credit_toggle_controller"
application.register("credit-toggle", CreditToggleController)

import DependentCheckboxController from "./dependent_checkbox_controller"
application.register("dependent-checkbox", DependentCheckboxController)

import EmbeddedVideoToggleController from "./embedded_video_toggle_controller"
application.register("embedded-video-toggle", EmbeddedVideoToggleController)

import ExperienceAddressController from "./experience_address_controller"
application.register("experience-address", ExperienceAddressController)

import ExperienceAnimationController from "./experience_animation_controller"
application.register("experience-animation", ExperienceAnimationController)

import ExperienceGalleryController from "./experience_gallery_controller"
application.register("experience-gallery", ExperienceGalleryController)

import FieldHintController from "./field_hint_controller"
application.register("field-hint", FieldHintController)

import FilterSelectOptionsController from "./filter_select_options_controller"
application.register("filter-select-options", FilterSelectOptionsController)

import FormInputController from "./form_input_controller"
application.register("form-input", FormInputController)

import FormStateController from "./form_state_controller"
application.register("form-state", FormStateController)

import GiftCreditsController from "./gift_credits_controller"
application.register("gift-credits", GiftCreditsController)

import GroupSelectController from "./group_select_controller"
application.register("group-select", GroupSelectController)

import HearAboutOtherController from "./hear_about_other_controller"
application.register("hear-about-other", HearAboutOtherController)

import HeroCarouselController from "./hero_carousel_controller"
application.register("hero-carousel", HeroCarouselController)

import HostReferralPointsController from "./host_referral_points_controller"
application.register("host-referral-points", HostReferralPointsController)

import ImageInputController from "./image_input_controller"
application.register("image-input", ImageInputController)

import InboxController from "./inbox_controller"
application.register("inbox", InboxController)

import LinkCustomerNotesController from "./link_customer_notes_controller"
application.register("link-customer-notes", LinkCustomerNotesController)

import LocationController from "./location_controller"
application.register("location", LocationController)

import MapCollapseController from "./map_collapse_controller"
application.register("map-collapse", MapCollapseController)

import MenuButtonController from "./menu_button_controller"
application.register("menu-button", MenuButtonController)

import MessagesController from "./messages_controller"
application.register("messages", MessagesController)

import MobileCarouselController from "./mobile_carousel_controller"
application.register("mobile-carousel", MobileCarouselController)

import MobileFiltersController from "./mobile_filters_controller"
application.register("mobile-filters", MobileFiltersController)

import ModalController from "./modal_controller"
application.register("modal", ModalController)

import MultiSortController from "./multi_sort_controller"
application.register("multi-sort", MultiSortController)

import NestedDropdownController from "./nested_dropdown_controller"
application.register("nested-dropdown", NestedDropdownController)

import NewsletterController from "./newsletter_controller"
application.register("newsletter", NewsletterController)

import PageSlugController from "./page_slug_controller"
application.register("page-slug", PageSlugController)

import PaymentMethodsController from "./payment_methods_controller"
application.register("payment-methods", PaymentMethodsController)

import PayoutController from "./payout_controller"
application.register("payout", PayoutController)

import PositionController from "./position_controller"
application.register("position", PositionController)

import PromotionalCodeController from "./promotional_code_controller"
application.register("promotional-code", PromotionalCodeController)

import RadioButtonsController from "./radio_buttons_controller"
application.register("radio-buttons", RadioButtonsController)

import RejectBookingController from "./reject_booking_controller"
application.register("reject-booking", RejectBookingController)

import RequiredFieldsController from "./required_fields_controller"
application.register("required-fields", RequiredFieldsController)

import RewriteSearchUrlController from "./rewrite_search_url_controller"
application.register("rewrite-search-url", RewriteSearchUrlController)

import SearchFormController from "./search_form_controller"
application.register("search-form", SearchFormController)

import SeatsChartController from "./seats_chart_controller"
application.register("seats-chart", SeatsChartController)

import SeatsEventsGenerateButtonController from "./seats_events_generate_button_controller"
application.register("seats-events-generate-button", SeatsEventsGenerateButtonController)

import SelectionHoldCountdownController from "./selection_hold_countdown_controller"
application.register("selection-hold-countdown", SelectionHoldCountdownController)

import SendGiftController from "./send_gift_controller"
application.register("send-gift", SendGiftController)

import SimpleInjectModalController from "./simple_inject_modal_controller"
application.register("simple-inject-modal", SimpleInjectModalController)

import SmoothScrollController from "./smooth_scroll_controller"
application.register("smooth-scroll", SmoothScrollController)

import StoriesController from "./stories_controller"
application.register("stories", StoriesController)

import StripeController from "./stripe_controller"
application.register("stripe", StripeController)

import TableExpandController from "./table_expand_controller"
application.register("table-expand", TableExpandController)

import TabsController from "./tabs_controller"
application.register("tabs", TabsController)

import ToggleTextController from "./toggle_text_controller"
application.register("toggle-text", ToggleTextController)

import TooltipToastController from "./tooltip_toast_controller"
application.register("tooltip-toast", TooltipToastController)

import UploadFieldController from "./upload_field_controller"
application.register("upload-field", UploadFieldController)

import ValidationController from "./validation_controller"
application.register("validation", ValidationController)

import WishlistController from "./wishlist_controller"
application.register("wishlist", WishlistController)

import YuupCheckboxSelectAllController from "./yuup_checkbox_select_all_controller"
application.register("yuup-checkbox-select-all", YuupCheckboxSelectAllController)

import TurnstileController from "./turnstile_controller"
application.register("turnstile", TurnstileController)
